export default "__VITE_ASSET__BUAm6tGe__"